import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn", "onItemClick", "description", "header", "containerLoading", "containerError", "navMarker", "errorMarker", "direction", "size", "flush", "resultTypes", "inferenceSource", "onInterest", "onNegativeFeedback", "cardsContainerProps", "onRenderEmpty"];
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { useRef, useState } from 'react';
import Raven from 'raven-js';
import { useRecommendationsState } from '../recommendationsStore.migrated';
import { usePostRankedRecommendationsFeedback } from 'academy-common-lib/features/recommendations/hooks/usePostRankedRecommendationsFeedback';
import { useRankedRecommendationsContent } from 'academy-common-lib/features/recommendations/hooks/useRankedRecommendationsContent';
import { InterestFeedbackTracker } from 'academy-common-lib/components/feedback/InterestFeedbackTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
export const RankedRecommendationsWithNegativeFeedback = _ref => {
  let {
      appearsIn,
      onItemClick,
      description,
      header,
      containerLoading,
      containerError,
      navMarker,
      errorMarker,
      direction,
      size,
      flush,
      resultTypes,
      inferenceSource,
      onInterest,
      onNegativeFeedback,
      cardsContainerProps,
      onRenderEmpty
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [maxCards, setMaxCards] = useState();
  const {
    isTablet
  } = useMediaQuery();
  const hasSentPositiveFeedbackRef = useRef(false);
  const {
    content,
    loading,
    error,
    correlationId
  } = useRankedRecommendationsContent({
    maxCards,
    inferenceSource,
    types: resultTypes
  });
  const showLoadingState = containerLoading || loading;
  const {
    postRankedRecommendationsFeedback
  } = usePostRankedRecommendationsFeedback();
  const showErrorState = error || containerError;
  const {
    setLastClickedRecommendationItem
  } = useRecommendationsState();
  const handleOnItemClick = (item, index) => {
    if (!hasSentPositiveFeedbackRef.current && correlationId && content) {
      hasSentPositiveFeedbackRef.current = true;
      postRankedRecommendationsFeedback({
        entityType: item.type,
        entityId: item.id,
        correlationId,
        content
      }).catch(Raven.captureException.bind(Raven));
      setLastClickedRecommendationItem({
        correlationId,
        item: {
          id: item.id,
          type: item.type
        },
        recommendationEngine: 'ranked'
      });
    }
    onItemClick === null || onItemClick === void 0 || onItemClick(item, index);
  };
  const handleOnNegativeFeedback = () => {
    if (!correlationId || !content) return;
    onNegativeFeedback === null || onNegativeFeedback === void 0 || onNegativeFeedback();
    postRankedRecommendationsFeedback({
      correlationId,
      content
    }).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsx(InterestFeedbackTracker, {
    bypassTrackingRef: hasSentPositiveFeedbackRef,
    onInterest: onInterest,
    onNegativeFeedback: handleOnNegativeFeedback,
    children: /*#__PURE__*/_jsx(CardsSection, Object.assign({
      appearsIn: appearsIn,
      cardsContainerProps: cardsContainerProps,
      content: content,
      description: description,
      direction: direction,
      error: showErrorState,
      errorMarker: errorMarker,
      flush: flush,
      header: header,
      isLoading: showLoadingState,
      maxSkeletonListLength: isTablet ? 3 : maxCards,
      navMarker: !showLoadingState && !showErrorState ? navMarker : undefined,
      onItemClick: handleOnItemClick,
      onItemMenuClick: handleOnItemClick,
      onRenderEmpty: onRenderEmpty,
      setMaxCards: setMaxCards,
      size: size
    }, props))
  });
};